import React from 'react';
import './PriorityBall.css';

const PrioColor = {
  1: 'red',
  2: 'orange',
  3: 'gray'
}

const PriorityBall = ({priority, handleAction}) => {
  const color = PrioColor[priority] ? PrioColor[priority] : 'teal';

  return (<div className='priorityBtn' onClick={handleAction}>
            <div className='priorityBall' style={{backgroundColor: color}} >
            </div>
          </div>
  );
};

export default PriorityBall;